import {useUser} from "../../context/UserContext";
import {useModal} from "../../context/ModalContext";
import {useAppContext} from "../../context/AppContext";
import React, {useEffect, useState} from "react";
import {Button, Checkbox, Divider, Input, InputNumber, Popover, Select, Typography} from "antd";
import PopoverScrollContent from "../../components/PopoverScrollContent";
import SelectPlan from "../SelectPlan";
import SelectionInfo from "../run-project/SelectionInfo";
import ProjectInfo from "../ProjectInfo";
import {CaretRightOutlined} from "@ant-design/icons";
import ApiService from "../../services/ApiService";
import {v4} from "uuid";
import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBody from "../../components/table/ResultBody";
import ResultBodyCell from "../../components/table/ResultBodyCell";

export default function XSAutomationTab({}) {
    const type = 'base';
    const { user } = useUser()
    const {openModal, closeModal} = useModal()
    const {selectedHistoryId, getSelectedHistory, dispatchProject, getSelectedRS, mapContext, getProjectLayers, getRiverBoundingCoords, getMapData, selection: selectionRef, resetShapeFilters, getSelectedProject, getSelectedPlan, toolbarItem, appContext, resolveSelection} = useAppContext()
    const selection = resolveSelection(selectionRef) || {base: {}, compare: {}}
    const [loading, setLoading] = useState(false)
    const [id, setId] = useState(null)
    const [selectedLayer, setSelectedLayer] = useState({
        streamCL: null,
        contour: null,
        xsExtend: null,
        streamFreq: 75,
        angle: 30,
        xsFreq: 10,
        boxFeet: 1,
        streamStartTolerance: 200,
        streamEndTolerance: 200,
        xsId: '',
        maxDepth: 10,
        minAngle: 150,
        boxDistance: 150
    })
    const [count, setCount] = useState(0)
    const [statusList, setStatusList] = useState([])

    function downloadJSON(data, filename) {
        const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // Dosya adı
        a.click();
        URL.revokeObjectURL(url);
    }


    const run = async () => {
        setLoading(true)
        setCount(0)
        setStatusList([])

        const id = v4()
        setId(id)

        const interval = setInterval(async () => {
            try {
                const res = await ApiService.RasCheck.GetStatusList({id})
                if(res.success) {
                    const jsonData = JSON.parse(res.data)
                    if(jsonData?.result?.length > 0) {
                        setStatusList((prev) => {
                            return [...prev, ...jsonData?.result].sort((a, b) => b.time - a.time);
                        })
                    }
                }
            }
            catch (e) {
                clearInterval(interval)
            }
        }, 1000)

        try {
            const layers = await getProjectLayers(type, selection)
            const input = {
                id,
                streamLayer: layers.find(x => x.id === selectedLayer.streamCL),
                xsLayer: layers.find(x => x.id === selectedLayer.xsExtend),
                contourLayer: layers.find(x => x.id === selectedLayer.contour),
                ...selectedLayer,
                streamFreq: selectedLayer.streamFreq * 0.3048,
                streamStartTolerance: selectedLayer.streamStartTolerance * 0.3048,
                streamEndTolerance: selectedLayer.streamEndTolerance * 0.3048,
                // maxDepth: selectedLayer.maxDepth * 0.3048,
                boxDistance: selectedLayer.boxDistance * 0.3048
            }


            const res = await ApiService.RasCheck.XSAutomation(input)
            if(res.success) {
                const _data = JSON.parse(res.data)
                const time = new Date().getTime()
                if(_data?.geojson_xs)
                {
                    downloadJSON(_data?.geojson_xs, `xs_cutline_${time}.json`)
                }

                if(_data?.geojson_segment)
                {
                    downloadJSON(_data?.geojson_segment, `xs_segment_${time}.json`)
                }

                if(_data?.geojson_contour)
                {
                    downloadJSON(_data?.geojson_contour, `xs_contour_${time}.json`)
                }

                setCount(_data?.xs_count)
            }
        }
        catch(error) {
            console.log(error)
        }

        setTimeout(() => {
            clearInterval(interval)
        }, 3000)

        setLoading(false)
    }

    // useEffect(() => {
    //     console.log(statusList)
    // }, [statusList]);

    return (
        <>
            <Popover
                placement={'bottomLeft'}
                trigger={'click'}
                content={
                    <PopoverScrollContent maxHeight={600}>
                        <SelectPlan type={type}/>
                    </PopoverScrollContent>
                }
            >
                <SelectionInfo type={'base'} />
            </Popover>
            <br/>
            <ProjectInfo
                autoHeight={true}
                showNotes={true}
                folderName={selection?.base.project?.information?.folderName}
                title={selection?.base.project?.information?.title}
                descriptions={
                    selection?.base.project?.information?.descriptions
                }
                planTitle={selection?.base.plan?.plan?.title}
                version={
                    selection?.base.project?.projectFiles &&
                    selection.base.project?.projectFiles?.length > 0 &&
                    selection?.base.plan?.plan?.version
                }
            />
            <Divider/>

            <table>
                <tbody>
                <tr>
                    <td>Stream Center Line</td>
                    <td>
                        <Select
                            size={'small'}
                            style={{width: 200, marginLeft: 16}}
                            onChange={e => setSelectedLayer({...selectedLayer, streamCL: e})}
                            value={selectedLayer.streamCL}
                        >
                            {getProjectLayers(type, selection)?.map(x => (
                                <Select.Option value={x.id} key={x.id}>
                                    {x.title}
                                </Select.Option>
                            ))}
                        </Select>
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            Stream centerline Shape File
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>XS Extend</td>
                    <td>
                        <Select
                            allowClear={true}
                            onClear={() => {
                                setSelectedLayer({
                                    ...selectedLayer,
                                    xsExtend: null
                                })
                            }}
                            size={'small'}
                            style={{width: 200, marginLeft: 16}}
                            onChange={e => setSelectedLayer({...selectedLayer, xsExtend: e})}
                            value={selectedLayer.xsExtend}
                        >
                            {getProjectLayers(type, selection)?.map(x => (
                                <Select.Option value={x.id} key={x.id}>
                                    {x.title}
                                </Select.Option>
                            ))}
                        </Select>
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            XS extend Shape File
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Contour</td>
                    <td>
                        <Select
                            size={'small'}
                            style={{width: 200, marginLeft: 16}}
                            onChange={e => setSelectedLayer({...selectedLayer, contour: e})}
                            value={selectedLayer.contour}
                        >
                            {getProjectLayers(type, selection)?.map(x => (
                                <Select.Option value={x.id} key={x.id}>
                                    {x.title}
                                </Select.Option>
                            ))}
                        </Select>
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            Contour data Shape File
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Box Feet Multiplier:</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.boxFeet}
                            onChange={e => setSelectedLayer({...selectedLayer, boxFeet: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>

                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Buffer Distance:</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.boxDistance}
                            onChange={e => setSelectedLayer({...selectedLayer, boxDistance: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>

                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Maximum Depth (ft):</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.maxDepth}
                            onChange={e => setSelectedLayer({...selectedLayer, maxDepth: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            (0: Disable)
                        </Typography.Text>
                    </td>
                </tr>
                {/*<tr>*/}
                {/*    <td>Min Angle:</td>*/}
                {/*    <td>*/}
                {/*        <InputNumber*/}
                {/*            style={{marginLeft: 16, width: 200}}*/}
                {/*            value={selectedLayer.minAngle}*/}
                {/*            onChange={e => setSelectedLayer({...selectedLayer, minAngle: e})}*/}
                {/*        />*/}
                {/*    </td>*/}
                {/*    <td>*/}
                {/*        <Typography.Text style={{marginLeft: 16}}>*/}
                {/*            Min distance between two XS GIS Cutline points*/}
                {/*        </Typography.Text>*/}
                {/*    </td>*/}
                {/*</tr>*/}
                <tr>
                    <td>Stream Frequency (ft):</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.streamFreq}
                            onChange={e => setSelectedLayer({...selectedLayer, streamFreq: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            Min distance between two XS
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Angle:</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.angle}
                            onChange={e => setSelectedLayer({...selectedLayer, angle: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            0: Disabled
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Skip Contour:</td>
                    <td>
                        <Checkbox
                            style={{marginLeft: 16, width: 200}}
                            checked={selectedLayer.skipAngle}
                            onChange={e => setSelectedLayer({...selectedLayer, skipAngle: e.target.checked})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>

                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Stream Start Tolerance (ft):</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.streamStartTolerance}
                            onChange={e => setSelectedLayer({...selectedLayer, streamStartTolerance: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            Threshold Length from stream start
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>Stream End Tolerance (ft):</td>
                    <td>
                        <InputNumber
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.streamEndTolerance}
                            onChange={e => setSelectedLayer({...selectedLayer, streamEndTolerance: e})}
                        />
                    </td>
                    <td>
                        <Typography.Text style={{marginLeft: 16}}>
                            Threshold Length from stream end
                        </Typography.Text>
                    </td>
                </tr>
                <tr>
                    <td>XS ID:</td>
                    <td>
                        <Input
                            style={{marginLeft: 16, width: 200}}
                            value={selectedLayer.xsId}
                            onChange={e => {
                                console.log(e)
                                setSelectedLayer({...selectedLayer, xsId: e.target.value})
                            }}
                        />
                    </td>
                    <td>

                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                        <Button
                            style={{marginLeft: 16, marginTop: 8, width: 200}}
                            loading={loading}
                            size={'small'}
                            type={'primary'}
                            icon={<CaretRightOutlined/>}
                            onClick={run}
                        >
                            Run XS Automation
                        </Button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div style={{
                maxHeight: 500,
                overflowY: 'auto',
                width: 750,
                marginTop: 16,
                display: statusList?.length === 0 ? 'none' : ''
            }}>
                <ResultTable>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{width: 200}}>
                                Time
                            </ResultHeaderCell>
                            <ResultHeaderCell>
                                Text
                            </ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {statusList.map(x => (
                            <ResultRow>
                                <ResultBodyCell>{new Date(x.time * 1000).toLocaleString()}</ResultBodyCell>
                                <ResultBodyCell style={{paddingRight: 8}}>{x.text}</ResultBodyCell>
                            </ResultRow>
                        ))}
                    </ResultBody>
                </ResultTable>
            </div>
        </>
    )
}